import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { all_routes } from '../../../router/all_routes';

interface UniversalWorklistLayoutProps {
  children: React.ReactNode;
}

const UniversalWorklistLayout: React.FC<UniversalWorklistLayoutProps> = ({ children }) => {
  const routes = all_routes;
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('tasks');

  // Tab configuration matching the Languages page style
  const tabs = [
    {
      key: 'tasks',
      label: 'Tasks',
      link: routes.todoWorklist.tasks,
    },
    {
      key: 'alerts',
      label: 'Alerts',
      link: routes.todoWorklist.alerts,
    },
    {
      key: 'notifications',
      label: 'Notifications',
      link: routes.todoWorklist.notifications,
    },
    {
      key: 'office-mails',
      label: 'SAPoffice Mails',
      link: routes.todoWorklist.officeMails,
    },
    {
      key: 'tracking',
      label: 'Tracking',
      link: routes.todoWorklist.tracking,
    }
  ];

  // Determine active tab based on current route
  React.useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.includes('/tasks')) setActiveTab('tasks');
    else if (currentPath.includes('/alerts')) setActiveTab('alerts');
    else if (currentPath.includes('/notifications')) setActiveTab('notifications');
    else if (currentPath.includes('/office-mails')) setActiveTab('office-mails');
    else if (currentPath.includes('/tracking')) setActiveTab('tracking');
  }, [location.pathname]);

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Header and Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Universal Worklist</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.employeeDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={routes.todoWorklist.main}>To-Do Work List</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Universal Worklist
                </li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="card">
          {/* Tab Navigation - Exact Languages page style */}
          <div className="card-header border-bottom-0 pb-0">
            <div className="d-flex align-items-center">
              {tabs.map((tab) => (
                <Link
                  key={tab.key}
                  to={tab.link}
                  className={`nav-link px-0 py-2 me-4 ${
                    activeTab === tab.key 
                      ? 'text-primary fw-medium border-bottom border-primary border-2' 
                      : 'text-muted'
                  }`}
                  style={{
                    textDecoration: 'none',
                    borderBottom: activeTab === tab.key ? '2px solid #0d6efd' : '2px solid transparent',
                    borderRadius: '0',
                    background: 'none'
                  }}
                  onClick={() => setActiveTab(tab.key)}
                >
                  <span>{tab.label}</span>
                </Link>
              ))}
            </div>
          </div>
          
          {/* Tab Content */}
          <div className="card-body">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniversalWorklistLayout;
